import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { createSucursal } from '../../../controller/sucursalController';
import Sucursal from '../../../models/sucursal'; // Asegúrate de que esta ruta sea correcta

function SucursalesCreateView() {
  const navigate = useNavigate();

  const [sucursal, setSucursal] = useState(new Sucursal({}));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSucursal({
      ...sucursal,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createSucursal(sucursal);
      navigate(-1); // Regresa a la vista anterior
    } catch (error) {
      console.error('Error al crear la sucursal:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Crear Sucursal</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={sucursal.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Dirección</Form.Label>
          <Form.Control
            type="text"
            name="address"
            value={sucursal.address}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Teléfono</Form.Label>
          <Form.Control
            type="text"
            name="phone_number"
            value={sucursal.phone_number}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={sucursal.email}
            onChange={handleChange}
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="me-2">
          Crear Sucursal
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      </Form>
    </Container>
  );
}

export default SucursalesCreateView;
